import sendRequest from "hooks/useAxios";
import { translateToReactSelect } from "../../utils/helperFunctions";
import { useState, useEffect } from "react";
import Creatable from "react-select/creatable";
import SunEditor from "suneditor-react";
import { createPortal } from "react-dom";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
export default function AddArticleModalData() {
  const navigation = useNavigate();
  const [localArticleData, setLocalArticleData] = useState({
    title: "",
    description: "",
    bodytxt: "",
    Hashtags: [],
    file: "",
    files: ""
  });
  let selectedHashtags = [];
  const [tagsOptions, setTagsOptions] = useState([]);
  useEffect(() => {
    sendRequest("Find_hashtags").then(({ data }) => {
      setTagsOptions(translateToReactSelect(data, false));
    });
  }, []);
  const changeHandler = (type, value) => {
    setLocalArticleData(prev => {
      return { ...prev, [type]: value };
    });
  };
  const [articleTag, setArticleTag] = useState([]);
  //  فرستادن برچسب های جدید به API

  const addPost = async hashtags => {
    let convertedHashtags = await Promise.all(
      hashtags.map(arrayItem => {
        if (arrayItem.__isNew__ == true) {
          let a = sendRequest("Insert_hashtags", { txt: arrayItem.label });
          return a;
        } else {
          return { data: { result: arrayItem } };
        }
      })
    );
    convertedHashtags = convertedHashtags.map(value => {
      return value.data.result;
    });

    const formData = new FormData();
    // ${translateToReactSelect(convertedHashtags, true)}

    for (const key in localArticleData) {
      switch (key) {
        case "Hashtags":
          formData.append(
            "addHashtag",
            translateToReactSelect(convertedHashtags, true)
          );

          break;

        case "file":
          formData.append("file", localArticleData.file);
          break;

        case "files":
          for (let i = 0; i < localArticleData.files.length; i++) {
            formData.append("files[]", localArticleData.files[i]);
          }
          break;

        case "postId":
          formData.append("postId", postId);
          break;

        default:
          formData.append(key, localArticleData[key]);
          break;
      }
    }
    let {
      data: { status, postId }
    } = await sendRequest("addpost", formData);

    if (status == 1) {
      toast.success("مقاله با موفقیت ایجاد شد.");
      document.querySelector("#addArticleModal .btn-close").click();
      navigation(`/article/${postId}`);
      // navigation to tak article
    } else {
      toast.error("مشکلی در افزودن مقاله به وجود آمد");
    }
  };
  const [validationLocalArticleData, setValidationLocalArticleData] = useState({
    title: true,
    description: true,
    bodytxt: true
  });
  const validation = () => {
    let isValid = true;
    if (localArticleData.title == "") {
      setValidationLocalArticleData(prev => {
        return { ...prev, title: false };
      });
      isValid = false;
    } else {
      setValidationLocalArticleData(prev => {
        return { ...prev, title: true };
      });
    }
    if (localArticleData.description == "") {
      setValidationLocalArticleData(prev => {
        return { ...prev, description: false };
      });
      isValid = false;
    } else {
      setValidationLocalArticleData(prev => {
        return { ...prev, description: true };
      });
    }
    if (localArticleData.bodytxt == "") {
      setValidationLocalArticleData(prev => {
        return { ...prev, bodytxt: false };
      });
      isValid = false;
    } else {
      setValidationLocalArticleData(prev => {
        return { ...prev, bodytxt: true };
      });
    }
    return isValid;
  };
  const addArticle = (
    <div
      className="modal fade"
      id="addArticleModal"
      tabIndex={-1}
      aria-labelledby="addArticleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5>افزودن مطلب</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <div>
              <form>
                <div className="row">
                  <label for="title" className="col-4">
                    عنوان
                  </label>
                  <div className="col-8">
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      value={localArticleData.title}
                      onChange={e => {
                        setLocalArticleData(prev => {
                          return { ...prev, title: e.target.value };
                        });
                      }}
                    />
                    <p
                      className={`text-danger fs-12 ${
                        validationLocalArticleData.title == false
                          ? "d-block"
                          : "d-none"
                      }`}
                    >
                      این فیلد نمی تواند خالی باشد
                    </p>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-4">
                    <label for="desc">توضیحات</label>
                  </div>
                  <div className="col-8">
                    {/* <input
                      type="text"
                      className="form-control"
                      id="desc"
                      onChange={e => {
                        setLocalArticleData(prev => {
                          return { ...prev, description: e.target.value };
                        });
                      }}
                    /> */}
                    <textarea
                      className="form-control"
                      style={{ height: "120px" }}
                      id="desc"
                      onChange={e => {
                        setLocalArticleData(prev => {
                          return { ...prev, description: e.target.value };
                        });
                      }}
                    ></textarea>
                    <p
                      className={`text-danger fs-12 ${
                        validationLocalArticleData.description == false
                          ? "d-block"
                          : "d-none"
                      }`}
                    >
                      این فیلد نمی تواند خالی باشد
                    </p>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-4">
                    <label for="file">تصویر اصلی</label>
                  </div>
                  <div className="col-8">
                    <input
                      type="file"
                      id="file"
                      name="file"
                      className="form-control"
                      onChange={e => {
                        setLocalArticleData(prev => {
                          return { ...prev, file: e.target.files[0] };
                        });
                      }}
                      // value={localArticleData.file}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-4">
                    <label for="files">باقی فایل ها</label>
                  </div>
                  <div className="col-8">
                    <input
                      type="file"
                      id="files"
                      name="files"
                      className="form-control"
                      multiple
                      onChange={e => {
                        setLocalArticleData(prev => {
                          return { ...prev, files: e.target.files };
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-4">
                    <label for="tags">برچسب</label>
                  </div>
                  <div className="col-8" style={{ zIndex: 999 }}>
                    <Creatable
                      id="Hashtags"
                      name="Hashtags"
                      options={tagsOptions}
                      isMulti={true}
                      className="mx-1"
                      onChange={e => {
                        setArticleTag(e);
                      }}
                      value={articleTag}
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div>
                    <label for="">متن اصلی</label>
                  </div>

                  <div className="mx-2 mt-2" style={{ direction: "rtl" }}>
                    <SunEditor
                      setOptions={{
                        height: 200,
                        buttonList: [
                          [],
                          [
                            "undo",
                            "redo",
                            "font",
                            "fontSize",
                            "formatBlock",
                            "bold",
                            "underline",
                            "strike",
                            "fontColor",
                            "textStyle",
                            "removeFormat",
                            "align",
                            "horizontalRule",
                            "list",
                            "lineHeight",
                            "link",
                            "image",
                            "video",
                            "audio",
                            "imageGallery",
                            "fullScreen",
                            "preview"
                          ]
                        ]
                      }}
                      setContents={localArticleData.bodytxt}
                      onChange={content => {
                        changeHandler("bodytxt", content);
                      }}
                    />
                  </div>
                </div>
                <p
                  className={`text-danger fs-12 ${
                    validationLocalArticleData.bodytxt == false
                      ? "d-block"
                      : "d-none"
                  }`}
                >
                  این فیلد نمی تواند خالی باشد
                </p>
              </form>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              بستن
            </button>
            <button
              type="submit"
              className="btn btn-success"
              onClick={async () => {
                if (validation()) {
                  addPost(articleTag);
                }
              }}
            >
              ذخیره
            </button>
          </div>
        </div>
      </div>
    </div>
  );
  return <>{createPortal(addArticle, document.getElementById("modals"))}</>;
}
